module.exports = __webpack_public_path__ + "static/media/clyde1945.22eb201e.png";